import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import MultiSelectProps from './MultiSelectProps'

import Animation from '../Common/Animation'
import Popup from '../Common/Popup'
import Virtual from '../Common/Virtual'

export default {
    props: MultiSelectProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Popup,
        Virtual
    ],
    mounted() {
        var that = this
        var widgetElement = that.$el

        kendo.jQuery(widgetElement).kendoMultiSelect(that.widgetOptions)

        if(this.v3) {
            this.ready()
        }

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', () => {
            if(that.v3){
                that.$emit('update:modelValue', that.kendoWidget().value())
            } else {
                that.$emit('changemodel', that.kendoWidget().value())
            }
        })
    },
    methods: {
        kendoWidget() {
            var widgetElement = this.$el

            return kendo.jQuery(widgetElement).getKendoMultiSelect()
        }
    },
    model: {
        event: 'changemodel'
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiSelect/KendoMultiSelectMixin.js